// Production Env
// WARNING: DO NOT USE FOR DEPLOYMENTS OTHER THAN PRODUCTION
export default {
  Region: 'us-east-2',
  UserPoolId: 'us-east-2_O83feeQ1u',
  ClientId: '4u5pf69t5kirjrak8eg3l3j8m',
  IdentityPoolId: 'us-east-2:ead9d441-5c1e-43a3-9daa-fd6bef10d9d6'
}



//////////////////
// WEBPACK FOOTER
// ./config/cognito.js
// module id = HonL
// module chunks = 1